import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-633d5ed9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "budget-card" }
const _hoisted_2 = { class: "unit" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "--", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "budget-recap__euro" }, "€", -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "duration" }
const _hoisted_9 = { class: "medias-global" }
const _hoisted_10 = { class: "medias" }
const _hoisted_11 = { class: "mr-2" }
const _hoisted_12 = ["href"]

import { useAccessDataStore } from '@/store/accessData';
    import { storeToRefs } from 'pinia';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'BudgetsRecap',
  setup(__props) {

    const accessData = useAccessDataStore();
    const { impressionsCount, visitsCount } = storeToRefs(accessData);
    const { budget, campaignDurationMin, campaignDurationMax } = storeToRefs(accessData);
    const { getMediasToDisplay } = storeToRefs(accessData);

    const mediasUrl = process.env.VUE_APP_MEDIAS_URL;

return (_ctx: any,_cache: any) => {
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _component_ad_icon = _resolveComponent("ad-icon")!
  const _component_b_badge = _resolveComponent("b-badge")!
  const _component_b_card = _resolveComponent("b-card")!
  const _directive_thousand_digits = _resolveDirective("thousand-digits")!
  const _directive_cents_to_euro = _resolveDirective("cents-to-euro")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_b_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, { class: "budget-recap mb-4" }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_directive_thousand_digits, _unref(impressionsCount)]
              ]),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('impressions')), 1)
            ]),
            (_unref(budget))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_cents_to_euro, _unref(budget)]
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
          ], undefined, true),
          _: 1
        }),
        _createVNode(_component_b_card_text, { class: "medias-recap" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t('duration')) + " : ", 1),
              _createElementVNode("div", null, [
                _createVNode(_component_ad_icon, {
                  size: "medium",
                  icon: "calendar",
                  class: "calendar-icon"
                }),
                _createElementVNode("span", null, _toDisplayString(_unref(campaignDurationMin)) + " - " + _toDisplayString(_unref(campaignDurationMax)) + " " + _toDisplayString(_ctx.$t('days')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('diffuseOn')) + " :", 1),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getMediasToDisplay), (media) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "media",
                    key: media
                  }, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t(media + '-access')), 1),
                    _createVNode(_component_b_badge, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ad_icon, { icon: media }, null, 8, ["icon"])
                      ], undefined, true),
                      _: 2
                    }, 1024)
                  ]))
                }), 128))
              ])
            ])
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    }),
    _createElementVNode("a", {
      href: _unref(mediasUrl),
      target: "_blank",
      class: "mediasLink"
    }, _toDisplayString(_ctx.$t('allAboutMedias')), 9, _hoisted_12)
  ]))
}
}

})